const initialValues = {
    prescriptionItems: [{
        orderId: "",
        prescriptionId: "",
        itemId: "",
        itemBatchId: "",
        itemBatches: [],
        time: "",
        meal: "",
        typeOfAdmin: "",
        doseSize: "",
        startDate: "",
        endDate: "",
        duration: "",
        discount: "",
    }]
}

export { initialValues }